<template>
  <div class="bto-sb-event-mormarket bto-sb-widget-prematch-full-view">
    <div class="bto-sb-mormarket-nav" v-if="match.matchId">
      <div class="bto-sb-mormarket-filter">
        <ul>
          <li
            :class="{'bto-sb-mormarket-filter-active' : selectedMarket === null}"
          >
            <a
              href="javascript:void(0);"
              title="All Markets"
              class="bto-sb-form-btn"
              @click="selectMarket(null)"
            >
              {{t('Mobile.AllMarkets')}}
            </a>
          </li>
          <li v-if="hasBetBuilder" :class="{'bto-sb-mormarket-filter-active' : selectedMarket === BB_TAB_ID}">
            <a
              href="javascript:void(0);"
              class="bto-sb-form-btn"
              @click="openBetBuilderOffer()"
            >
              {{t("BB.BetBuilder")}}
            </a>
          </li>
          <li
            v-for="(market, idx) in match.tabs.slice(0, numOfMarketsToSlice)"
            :key="idx"
            :class="{'bto-sb-mormarket-filter-active' : selectedMarket === market.id}"
          >
            <a
              class="bto-sb-form-btn"
              href="javascript:void(0);"
              :title="market.name"
              @click="selectMarket(market.id)"
            >
              {{market.name}}
            </a>
          </li>
          <li :class="{'bto-sb-mormarket-filter-active' : selectedMarket === outrightsMarketId}"
            v-if="outrightsMarketId !== -10">
            <a title="Outrights"
              class="bto-sb-form-btn"
              @click="selectMarket(outrightsMarketId)">
              {{t('Mobile.Outrights')}}
            </a>
          </li>
          <li :class="{'bto-sb-mormarket-filter-active' : selectedMarket === 'player-markets'}"
              v-if="playerTab.groups && playerTab.groups.length > 0">
              <a :title="playerTab.name"
                  class="bto-sb-form-btn"
                  @click="selectMarket('player-markets')">
                  {{playerTab.name}}
              </a>
          </li>
          <li :class="{'bto-sb-mormarket-filter-active' : selectedMarketInDropdown()}">
            <div class="bto-sb-form-select">
              <select
                :disabled="match.tabs.length <= 3 && !playerOdds.length && !scorecast.odds.length && (showCashoutTab === true && !hasCashoutOdds)"
                @change="selectMarket($event.target.value)"
              >
                <option
                  selected
                  disabled
                  v-if="!selectedMarketInDropdown()"
                >
                  {{t('Mobile.SelectMarket')}}
                </option>
                <option
                  v-for="(market, idx) in match.tabs.slice(numOfMarketsToSlice).filter(m=>m.id!==outrightsMarketId)"
                  :key="idx"
                  :value="market.id"
                >
                  {{market.name}}
                </option>
                <option
                  v-if="playerOdds.length"
                  value="playerOdds"
                >
                  {{t('Global.OddType.GoalScorers')}}
                </option>
                <option
                  v-if="scorecast.id && scorecast.odds.length"
                  value="scorecast"
                >
                  {{t('Public.ScoreCast')}}
                </option>
                <option
                  v-if="showCashoutTab && hasCashoutOdds"
                  value="cashout"
                >
                  {{t('Mobile.cashout')}}
                </option>
              </select>
              <div class="bto-sb-form-select-arrow"></div>
            </div>
          </li>
        </ul>
      </div>
      <div class="bto-sb-mormarket-grid">
        <a
          href="javascript:void(0);"
          :title="`${t('W.fView')}`"
          :class="{'bto-sb-mormarket-grid-active' : columns === 1}"
          @click="changeView(1)"
        ></a>
        <a
          href="javascript:void(0);"
          :title="`${t('W.gView')}`"
          :class="{'bto-sb-mormarket-grid-active' : columns === 2}"
          @click="changeView(2)"
        ></a>
      </div>
    </div>
    <!-- start - render tabs + markets -->
    <div class="bto-sb-mormarket-content" :class="getViewClass()" data-bto-game-markets>
      <template v-if="selectedMarket !== BB_TAB_ID">
        <template v-for="(tab, tabIdx) in match.tabs">
          <template v-if="selectedMarket === tab.id || selectedMarket === null || selectedMarket === 'cashout'">
            <template v-for="(odd, oddIdx) in selectedMarket === 'cashout' ?
                match.tabs[tabIdx].odds.filter(o => o.cashout === true) :
                match.tabs[tabIdx].odds
              ">
              <tab-market-component
                :key="tabIdx * 1000 + oddIdx"
                :match="match"
                :tabIdx="tabIdx"
                :odd="odd"
                :oddIdx="oddIdx"
                :selectedMarket="selectedMarket"
                :isItDuplicateMarket="isItDuplicateMarket"
              />
            </template>
          </template>
        </template>
        <player-markets-component :match="match" :groups="playerTab.groups || []" v-if="selectedMarket === null || selectedMarket === 'player-markets'"/>
      </template>
      <inline-message
        v-if="selectedMarket === BB_TAB_ID"
        :message="t('BB.MinimumTwoSelections')"
        type="info"
      />
      <template v-if="selectedMarket === BB_TAB_ID">
        <BetBuilderTab v-for="(tab, key, idx) in betBuilderTabs" :key="key" :tab="tab" :tabIdx="idx" :fixture="betBuilderFixture" />
      </template>
      <!-- end - render tabs + markets -->
      <outrights-tab-market v-if="showOutrights" :tab="outrightMarketTab" />
      <!-- start - player odds 'dropdowns' view tab -->
      <div
        v-if="playerOddsViewType === 'dropdowns' && playerOdds.length && (selectedMarket === 'playerOdds' || selectedMarket === null)"
        class="bto-sb-event-mormarket-market"
      >
        <div class="bto-sb-event-mormarket-market-name bto-sb-bar-filter">
          <h4>{{t('Global.OddType.GoalScorers')}}</h4>
        </div>
        <div class="bto-sb-event-mormarket-market-odd">
          <span>
            <div class="bto-sb-form-select">
              <select
                v-model="selectedPlayer"
              >
                <option
                  selected
                  v-if="!selectedPlayer"
                  :value="undefined"
                >
                  {{t('W.SelectPlayer')}}
                </option>
                <option
                  v-for="(playerName, idx) in distinctPlayers"
                  :key="idx"
                  :value="playerName"
                >
                  {{playerName}}
                </option>
              </select>
              <div class="bto-sb-form-select-arrow"></div>
            </div>
          </span>
          <span>
            <div class="bto-sb-form-select">
              <select
                :disabled="!selectedPlayer"
                v-model="selectedPlayerOddType"
              >
                <option
                  v-if="!selectedPlayerOddType"
                  :value="undefined"
                >
                  {{t('W.SelectOddType')}}
                </option>
                <option
                  v-for="(oddType, idx) in selectedPlayer ? [
                    {
                      identifier: 'first',
                      name: t('Mobile.FirstGoalScorer'),
                    },
                    {
                      identifier: 'any',
                      name: t('Mobile.AnyGoalScorer'),
                    },
                    {
                      identifier: 'last',
                      name: t('Mobile.LastGoalscorer'),
                    }
                  ]: []"
                  :key="idx"
                  :value="oddType.identifier"
                >
                  {{oddType.name}}
                </option>
              </select>
              <div class="bto-sb-form-select-arrow"></div>
            </div>
          </span>
          <span>
            <match-odd-component
              v-if="selectedPlayer && selectedPlayerOddType"
              :match="match"
              :odd="{}"
              :outcome="getSelectedPlayerOdd()"
              :isDetails="true"
            />
            <match-odd-component
              v-else
              :match="match"
              :odd="{}"
              :outcome="{
                id: 'N/A',
                name: t('W.NA'),
                originalDecimalOutcome: '--'
              }"
              :isDetails="true"
            />
          </span>
        </div>
      </div>
      <!-- end - player odds 'dropdowns' view tab -->
      <div
        v-if="scorecast.id && scorecast.odds.length && (selectedMarket === 'scorecast' || selectedMarket === null)"
        class="bto-sb-event-mormarket-market"
      >
        <div class="bto-sb-event-mormarket-market-name">
          <h4>{{t('Public.ScoreCast')}}</h4>
        </div>
        <div class="bto-sb-mormarket-nav">
          <div class="bto-sb-mormarket-filter">
            <ul>
              <li
                v-for="(scorecastTab, idx) in scorecast.odds"
                :key="idx"
                :class="{'bto-sb-mormarket-filter-active': selectedScorecastTabIdx === idx}"
              >
                <a
                  href="javascript:void(0);"
                  class="bto-sb-form-btn"
                  @click="selectScorecastTab(idx)"
                >{{scorecastTab.marketName}}</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="bto-sb-event-mormarket-market-odd">
          <span>
            <div class="bto-sb-form-select">
              <select v-model="selectedScorecastPlayerIdx" @change="scorecastPlayerUpdated()">
                <option v-if="selectedScorecastPlayerIdx === undefined" selected disabled :value="undefined">
                  {{t('W.SelectPlayer')}}
                </option>
                <option
                  v-for="(player, idx) in scorecast.odds[selectedScorecastTabIdx].players"
                  :key="idx"
                  :value="idx"
                >
                  {{player.name}}
                </option>
              </select>
              <div class="bto-sb-form-select-arrow"></div>
            </div>
          </span>
          <span>
            <div
              class="bto-sb-form-select"
              :class="{'bto-sb-form-btn-disabled': selectedScorecastPlayerIdx === undefined}"
            >
              <select v-model="selectedScorecastPlayerOutcomeIdx">
                <option v-if="selectedScorecastPlayerIdx === undefined" selected disabled :value="undefined">--</option>
                <template v-if="selectedScorecastPlayerIdx !== undefined">
                  <option selected disabled :value="undefined" v-if="selectedScorecastPlayerOutcomeIdx === undefined">
                    {{t('W.SelectOdd')}}
                  </option>
                  <option
                    v-for="(odd, idx) in scorecast.odds[selectedScorecastTabIdx].players[selectedScorecastPlayerIdx].outcomes"
                    :key="idx"
                    :value="idx"
                  >
                    {{odd.name}} ({{odd.originalDecimalOutcome | formatOddDisplay($root.oddFormat)}})
                  </option>
                </template>
              </select>
              <div class="bto-sb-form-select-arrow"></div>
            </div>
          </span>
          <span>
            <match-odd-component
              v-if="selectedScorecastPlayerIdx !== undefined && selectedScorecastPlayerOutcomeIdx !== undefined"
              :match="match"
              :odd="{
                marketName: scorecast.odds[selectedScorecastTabIdx].players[selectedScorecastPlayerIdx].name
              }"
              :outcome="scorecast.odds[selectedScorecastTabIdx].players[selectedScorecastPlayerIdx].outcomes[selectedScorecastPlayerOutcomeIdx]"
              :isDetails="true"
            />
            <match-odd-component
              v-else
              :match="match"
              :odd="{}"
              :outcome="{
                id: 'N/A',
                name: t('W.NA'),
                originalDecimalOutcome: '--'
              }"
              :isDetails="true"
            />
          </span>
        </div>
      </div>
    </div>
    <!-- start - player odds 'all' view tab -->
    <div
      v-if="playerOddsViewType === 'all' && playerOdds.length && (selectedMarket === 'playerOdds' || selectedMarket === null)"
      :class="[
        'bto-sb-widget-content',
        'bto-sb-event-mormarket-full',
        'bto-sb-event-market-player',
        {'bto-sb-widget-prematch-full-view': latamLayout && playerOdds.length}
      ]"
    >
      <div class="bto-sb-event-odds-nav">
        <div class="bto-sb-event-odds-nav-labels">
          <div class="bto-sb-event-odds-left">
            <div class="bto-sb-event-odds-cell bto-sb-event-eventlabel">{{t('Global.OddType.GoalScorers')}}</div>
          </div>
          <div class="bto-sb-event-odds-right">
            <div class="bto-sb-event-odds-cell">
              <span class="bto-sb-event-marketlabel">{{t('Mobile.FirstGoalScorer')}}</span>
              <span class="bto-sb-event-marketlabel">{{t('Mobile.AnyGoalScorer')}}</span>
              <span class="bto-sb-event-marketlabel">{{t('Mobile.LastGoalscorer')}}</span>
              <!-- <span class="bto-sb-event-marketlabel">{{t('PlayerOddType.HatTrick')}}</span>
              <span class="bto-sb-event-marketlabel">{{t('PlayerOddType.TwoOrMoreGoals')}}</span> -->
            </div>
          </div>
        </div>
      </div>
      <div class="bto-sb-event-odds-content">
        <div
          v-for="(player, idx) in playerOdds"
          :key="idx"
          class="bto-sb-event-odds"
        >
          <div class="bto-sb-event-odds-left">
            <div class="bto-sb-event-name">
              <a href="javascript:void(0);" title="Hallam Robert Hope">
                <div class="bto-sb-event-wrap">
                  <span class="bto-sb-event-team">
                    <span class="bto-sb-event-home">{{player.firstName}} {{player.lastName}}</span>
                  </span>
                </div>
                <div class="bto-sb-event-description">{{player.teamName}}</div>
              </a>
            </div>
          </div>
          <div class="bto-sb-event-odds-right">
            <div class="bto-sb-event-odds-cell">
              <match-odd-component
                :match="match"
                :odd="{
                  marketName: player.firstName,
                  competitorId: player.competitorId
                }"
                :outcome="{
                  id: `p-o-${match.matchId}-${player.competitorId}-${player.playerId}-${playerOddIds.first}`,
                  name: t('Mobile.FirstGoalScorer'),
                  originalDecimalOutcome: player.originalFirstGoalOdd,
                  playerOddId: playerOddIds.first,
                  playerId: player.playerId
                }"
              />
              <match-odd-component
                :match="match"
                :odd="{
                  marketName: player.firstName,
                  competitorId: player.competitorId
                }"
                :outcome="{
                  id: `p-o-${match.matchId}-${player.competitorId}-${player.playerId}-${playerOddIds.any}`,
                  name: t('Mobile.AnyGoalScorer'),
                  originalDecimalOutcome: player.originalAnyGoalOdd,
                  playerOddId: playerOddIds.any,
                  playerId: player.playerId
                }"
              />
              <match-odd-component
                :match="match"
                :odd="{
                  marketName: player.firstName,
                  competitorId: player.competitorId
                }"
                :outcome="{
                  id: `p-o-${match.matchId}-${player.competitorId}-${player.playerId}-${playerOddIds.last}`,
                  name: t('Mobile.LastGoalscorer'),
                  originalDecimalOutcome: player.originalLastGoalOdd,
                  playerOddId: playerOddIds.last,
                  playerId: player.playerId
                }"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end - player odds 'all' view tab -->
    <!-- end - render tabs + markets -->
    <div class="bto-sb-widget-content" v-if="!match.matchId">
      <empty-state :message="t('W.EmptyMatchDetails')" :icon-class="EMPTY_STATE_ICON" />
    </div>
    <div class="bto-sb-mormarket-footer">
      <a class="bto-sb-form-btn" href="#" :title="t('Public.Close')" @click.prevent="closeEmbededDetails()">
        {{t('Public.Close')}}
      </a>
    </div>
  </div>
</template>

<script>
  import MatchDetailsWidget from '../widget-match-details';

  export default {
    name: 'EmbededMatchDetails',
    extends: MatchDetailsWidget,
    props: {
      latamLayout: {
        type: Boolean,
        default: false,
      }
    },
  };
</script>
